// Angular
import { Component, SimpleChanges, OnChanges, input } from '@angular/core';

// NGRX
import { Store } from '@ngrx/store';

// Miscellaneous
import * as fromRoot from '../../../reducers';
import { constants } from '../../../constants';
import * as tracking from '../../../actions/tracking';
import { GuestService } from '../../core/services/guest.service';
import { GatingServices } from '../../core/services/gating.services';
import { BookingService } from '../../core/services/booking.service';

@Component({
    selector: 'app-cruise-history',
    templateUrl: './modal-cruise-history.component.html',
    styleUrls: ['./modal-cruise-history.component.scss'],
    standalone: false
})
export class ModalCruiseHistoryComponent implements OnChanges {
	public readonly layoutState = input<string>();
	public readonly bundle = input<any>(null);

	public showMenu: boolean;
	public exitModal = constants.MODAL.EXIT;
	public historyModalState: string;
	public showHistoryModal = false;
	public hasloyaltyNumber = false;
	public brandName: string;

	constructor(
		private readonly store: Store<fromRoot.AppState>,
		private readonly gatingServices: GatingServices,
		private readonly guestService: GuestService,
		private readonly bookingService: BookingService
	) {
		this.hasloyaltyNumber = this.gatingServices.getLoyaltyData();
		this.brandName = this.bookingService.getBrand();
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes['layoutState']) {
			const layoutState = changes['layoutState'].currentValue;

			if (layoutState && layoutState.openedModalName === constants.MODAL.CRUISE_HISTORY) {
				this.showHistoryModal = true;
				this.historyModalState = 'first';
				this.store.dispatch(new tracking.TrackPageInteractionEventAction('modal: new to cruise: is this your first cruise?'));
				const inert = document.createAttribute('inert');
				document.getElementById('main')?.setAttributeNode(inert);
			} else if (layoutState && layoutState.openedModalName === 'close') {
				this.showHistoryModal = false;
				document.getElementById('main')?.removeAttribute('inert');
			}
		}
	}

	public closeModal(text: any): void {
		this.showHistoryModal = false;
		this.historyModalState = 'none';
		document.getElementById('main')?.removeAttribute('inert');
		if (text === 'skip') {
			this.store.dispatch(
				new tracking.TrackPageInteractionEventAction('modal: new to cruise: is this your first cruise? user select: skip')
			);
		}
	}

	public historyModalContinue(surveyResponse: any) {
		this.guestService.saveIsYourFirstCruiseVacation(surveyResponse);

		this.historyModalState = 'thanks';

		const userSelection = surveyResponse ? 'yes' : 'no';
		this.store.dispatch(
			new tracking.TrackPageInteractionEventAction('modal: new to cruise: is this your first cruise? user select: ' + userSelection)
		);
	}
}
